import { Route, Routes } from 'react-router-dom';
import { LoginPage } from './Login';
import { RegistrationPage } from './Registration';
import { RegistrationCompletePage } from './RegistrationComplete';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="register" element={<RegistrationPage />} />
      <Route path="register/complete" element={<RegistrationCompletePage />} />
    </Routes>
  );
};
